import React, { useState } from 'react';
import { LayoutGrid, Layers, GitBranch, Radio, Settings, LogOut } from 'lucide-react';
import AgentInterface from './AgentInterface';
import SkillGraph from './SkillGraph';
import BranchingMindMap from './BranchingMindMap';
import BeaconDashboard from './BeaconDashboard';
import SettingsScreen from './SettingsScreen';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
interface ProfessionalGrowthDashboardProps {
  activeTab?: 'agent' | 'graph' | 'branching' | 'beacon';
}
const ProfessionalGrowthDashboard = ({
  activeTab = 'agent'
}: ProfessionalGrowthDashboardProps) => {
  const [currentTab, setCurrentTab] = useState<'agent' | 'graph' | 'branching' | 'beacon'>(activeTab);
  const [showSettings, setShowSettings] = useState(false);
  const {
    logout,
    user
  } = useAuth();
  // This would normally be derived from your actual data
  // Here we're hard-coding it for demonstration
  const hasAnsweredRequests = true;
  if (showSettings) {
    return <SettingsScreen onBack={() => setShowSettings(false)} data-id="element-754" />;
  }
  return <div className="w-full min-h-screen flex flex-col" data-id="element-755">
      <header className="bg-white shadow-sm border-b border-gray-200" data-id="element-756">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-757">
          <div className="flex justify-between items-center" data-id="element-758">
            <h1 className="text-xl font-semibold text-gray-800" data-id="element-759">
              {user?.name && <span className="text-sm font-normal text-gray-500 mr-2" data-id="element-760">
                  Welcome, {user.name}
                </span>}
            </h1>
            <div className="flex space-x-2" data-id="element-761">
              <Link to="/" className="px-4 py-2 rounded-md bg-gray-100 text-gray-700 hover:bg-gray-200 flex items-center" data-id="element-762">
                Dashboard
              </Link>
              <button onClick={() => setCurrentTab('agent')} className={`px-4 py-2 rounded-md flex items-center ${currentTab === 'agent' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-763">
                <LayoutGrid className="w-5 h-5 mr-2" data-id="element-764" />
                <span className="hidden sm:inline" data-id="element-765">Growth Agent</span>
              </button>
              <button onClick={() => setCurrentTab('graph')} className={`px-4 py-2 rounded-md flex items-center ${currentTab === 'graph' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-766">
                <Layers className="w-5 h-5 mr-2" data-id="element-767" />
                <span className="hidden sm:inline" data-id="element-768">Capacity</span>
              </button>
              <button onClick={() => setCurrentTab('branching')} className={`px-4 py-2 rounded-md flex items-center ${currentTab === 'branching' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-769">
                <GitBranch className="w-5 h-5 mr-2" data-id="element-770" />
                <span className="hidden sm:inline" data-id="element-771">Branching</span>
              </button>
              <button onClick={() => setCurrentTab('beacon')} className={`px-4 py-2 rounded-md flex items-center ${currentTab === 'beacon' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-772">
                <Radio className={`w-5 h-5 mr-2 ${hasAnsweredRequests ? 'text-green-500' : ''}`} data-id="element-773" />
                <span className="hidden sm:inline" data-id="element-774">Beacon</span>
                {hasAnsweredRequests && <span className="ml-1 w-2 h-2 bg-green-500 rounded-full" data-id="element-775"></span>}
              </button>
              <button onClick={() => setShowSettings(true)} className="p-2 rounded-md bg-gray-100 text-gray-700 hover:bg-gray-200 flex items-center justify-center" aria-label="Settings" data-id="element-776">
                <Settings className="w-5 h-5" data-id="element-777" />
              </button>
              <button onClick={logout} className="p-2 rounded-md bg-red-100 text-red-700 hover:bg-red-200 flex items-center justify-center" aria-label="Logout" data-id="element-778">
                <LogOut className="w-5 h-5" data-id="element-779" />
              </button>
            </div>
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-6" data-id="element-780">
        <div className="h-[80vh]" data-id="element-781">
          {/* Show only the active tab on all screen sizes */}
          {currentTab === 'agent' && <AgentInterface data-id="element-782" />}
          {currentTab === 'graph' && <SkillGraph data-id="element-783" />}
          {currentTab === 'branching' && <BranchingMindMap data-id="element-784" />}
          {currentTab === 'beacon' && <BeaconDashboard data-id="element-785" />}
        </div>
      </main>
    </div>;
};
export default ProfessionalGrowthDashboard;